import React, { useState } from 'react';
import { HomeAboutData } from '../../helper/Helper';

function About() {
    const [showAll, setShowAll] = useState(false);

    // Determine the data to display based on showAll state
    const displayedData = showAll ? HomeAboutData : HomeAboutData.slice(0, 2);

    return (
        <div className='wrapper mx-auto pt-4'>
            {displayedData.map((data, index) => (
                <div key={index} className='mb-4'>
                    {data.mainHeading && (
                        <h4 className='text-white fw-semibold fs-22 mb-4'>{data.mainHeading}</h4>
                    )}
                    {data.heading && (
                        <h5 className='text-white opacity-75 fs-18 mt-3 mb-0'>{data.heading}</h5>
                    )}
                    {data.pera && data.pera.map((pera, pIndex) => (
                        <p key={pIndex} className='text-white opacity-75 fs-18 leading-150 m-0'>{pera}</p>
                    ))}
                </div>
            ))}
            <div className='text-center'>
                <button onClick={() => setShowAll(!showAll)} className='btn ease-in-out3ms bg-cherrygradient hover-bg-cherrygradient text-white fw-medium mt-4 px-4 px-lg-5'>
                    {showAll ? 'Close' : 'Show More'}
                </button>
            </div>
        </div>
    );
}

export default About;
